export default __webpack_public_path__ + "static/media/hraicon-1.1bbaf26c.png";